// フォーム初期値
const initializer = () => {
  return {
    bank_account_holder: '', // 口座名義人
    bank_account_holder_name: '', // 名義人入力
    bank_account_registration: '', // 口座登録
    bank_account_registration_date: '', // 口座登録日
    is_beri: false, // 本人確認電話フラグ
    beri_timing: '審査後すぐ', // 確認日時
    beri_at: null,
    identification: [], // 本人確認書類
    contract_documents: [], // エステ契約書、美容医療契約書、売買契約書、口座振替依頼書等
    parental_consent: [] // 親権者同意書
  }
}

const state = {
  form: initializer(),
  validations: [] // php側のバリデーション
}

const mutations = {
  put(state, uploadData) {
    state.form = Object.assign(state.form, uploadData)
  },
  remove(state) {
    state.form = initializer()
  },
  // php側のバリデーションエラー更新
  updateValidations(state, validations) {
    state.validations = validations
  }
}

const actions = {
  // php側のバリデーションエラー更新
  updateValidations({commit}, validations) {
    commit('updateValidations', validations)
  },
  setForm({commit}, form) {
    commit('put', form)
  },
  initForm({commit}) {
    commit('remove')
  }
}

const getters = {
  getForm(state) {
    return state.form
  },
  getValidations(state) {
    return state.validations
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
